const sms = require("../sms");
const cafe = {
    sms: {
        extension: sms.extension,
        chrome_undefined: sms.extension.undefined,
    },
};

const sendMessage = (port) => {
    let resolve;
    let p = new Promise(r => resolve = r);
    if (typeof (window) === "undefined" || !window.chrome || !window.chrome.runtime) {
        resolve({ is_success: false, error: cafe.sms.chrome_undefined });
        return p;
    };
    const ext = require("../../../plugins/filters").extension.chrome;
    window.chrome.runtime.sendMessage(ext.id, port, (res) => {
        if (window.chrome.runtime.lastError) resolve({ error: cafe.sms.extension.not_found });
        else resolve(res);
    });

    return p;
};

module.exports = {
    sendMessage,
};


// WEBPACK FOOTER //
// src/utils/api/chrome/api.chrome.runtime.js